import { AxiosPagePromise, BaseService } from './BaseService';
import { resources } from '../resources';
import { AxiosPromise, type RawAxiosRequestConfig } from 'axios';
import { SupplierCarDto } from '../models/suppliers/SupplierCarDto';
import { Page } from '../models/common/Page';
import { SupplierCarQueryParams } from '../params/SupplierCarQueryParams';
import { SupplierCarCreateUpdate } from '../models/suppliers/SupplierCarCreateUpdate';
import { SupplierCarTypeDto } from '../models/suppliers/SupplierCarTypeDto';

export class SupplierCarService extends BaseService {
  public getAllBySupplier(args?: SupplierCarQueryParams, options: RawAxiosRequestConfig = {}): AxiosPagePromise<SupplierCarDto> {
    return this.get<Page<SupplierCarDto>>(resources.getAllBySupplier, args, options);
  }
  public getSupplierCars(args?: SupplierCarQueryParams, options: RawAxiosRequestConfig = {}): AxiosPagePromise<SupplierCarDto> {
    return this.get<Page<SupplierCarDto>>(resources.getSupplierCars, args, options);
  }
  public getSupplierCarById(carId: string, options: RawAxiosRequestConfig = {}): AxiosPromise<SupplierCarDto> {
    return this.get<SupplierCarDto>(resources.getSupplierCarById, { carId: carId }, options);
  }
  public getAllCarTypesByCompany(): AxiosPromise<SupplierCarTypeDto[]> {
    return this.get<SupplierCarTypeDto[]>(resources.getAllCarTypesByCompany);
  }
  public createSupplierCar(supplierId: string, body: SupplierCarCreateUpdate, options: RawAxiosRequestConfig = {}): AxiosPromise<SupplierCarDto> {
    return this.post<SupplierCarDto>(resources.createSupplierCar, body, { supplierId: supplierId }, options);
  }
  public updateSupplierCar(carId: string, body: SupplierCarCreateUpdate, options: RawAxiosRequestConfig = {}): AxiosPromise<SupplierCarDto> {
    return this.put<SupplierCarDto>(resources.updateSupplierCar, body, { id: carId }, options);
  }
  public deleteSupplierCar(carId: string): AxiosPromise<SupplierCarDto> {
    return this.delete<SupplierCarDto>(resources.deleteSupplierCar, { id: carId });
  }

  // -> car types
  public createCarType(body: SupplierCarTypeDto): AxiosPromise<SupplierCarDto> {
    return this.post<SupplierCarDto>(resources.createCarType, body);
  }
  public updateCarType(carTypeId: string, body: SupplierCarTypeDto): AxiosPromise<SupplierCarDto> {
    return this.put<SupplierCarDto>(resources.updateCarType, body, { carTypeId: carTypeId });
  }
  public deleteCarType(carTypeId: string): AxiosPromise<SupplierCarDto> {
    return this.delete<SupplierCarDto>(resources.deleteCarType, { carTypeId: carTypeId });
  }
  // <- car types
}
